function updateHeaderCartCount(parsedState) {
  const cartIconBubble = document.getElementById('cart-icon-bubble');
  if (!cartIconBubble) return;

  const cartIconSection = parsedState.sections && parsedState.sections['cart-icon-bubble'];
  if (cartIconSection) {
    const parsedHTML = new DOMParser().parseFromString(cartIconSection, 'text/html');
    const source = parsedHTML.querySelector('.shopify-section');
    if (source) {
      cartIconBubble.innerHTML = source.innerHTML;
    }
  }

  fetch(`${routes.cart_url}.js`)
    .then((response) => response.json())
    .then((cart) => {
      const countBubble = cartIconBubble.querySelector('.cart-count-bubble') || document.createElement('div');
      countBubble.className = 'cart-count-bubble';

      if (cart.item_count > 0) {
        countBubble.innerHTML =
          cart.item_count < 100
            ? `<span aria-hidden="true">${cart.item_count}</span><span class="visually-hidden">${cart.item_count} items</span>`
            : '<span class="visually-hidden">99+ items</span>';

        if (!countBubble.parentElement) {
          cartIconBubble.appendChild(countBubble);
        }
      } else if (countBubble.parentElement) {
        countBubble.remove();
      }
    })
    .catch(() => {
      const addedQuantity = parseInt(parsedState.quantity, 10) || 1;
      const countBubble = cartIconBubble.querySelector('.cart-count-bubble') || document.createElement('div');
      const currentCount = parseInt(countBubble.querySelector('[aria-hidden="true"]')?.textContent, 10) || 0;
      const fallbackCount = currentCount + addedQuantity;

      countBubble.className = 'cart-count-bubble';
      countBubble.innerHTML = `<span aria-hidden="true">${fallbackCount}</span><span class="visually-hidden">${fallbackCount} items</span>`;

      if (!countBubble.parentElement) {
        cartIconBubble.appendChild(countBubble);
      }
    });
}

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          const sectionsToRender = this.cart.getSectionsToRender().map((section) => section.id);
          if (!sectionsToRender.includes('cart-icon-bubble')) sectionsToRender.push('cart-icon-bubble');

          formData.append('sections', sectionsToRender);
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            updateHeaderCartCount(response);

            if (!this.error)
              try {
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  cartData: response,
                });
              } catch (error) {
                console.error(error);
              }
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                    updateHeaderCartCount(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
              updateHeaderCartCount(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
